module.exports = __webpack_public_path__ + "img/08.7a148606.jpg";